import { createSelector } from 'reselect';

export const selectNavigationBar = (state) => state.NavigationBar;
export const selectDarkToggle = createSelector(
  selectNavigationBar,
  (NavigationBar) => NavigationBar.darkToggle,
);
